// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Group } from "../../data/app-core/group";
import { CloakType } from "../../data/app-core/cloak-type";
import { SearchRequestType } from "../../data/app-core/search-request-type";
import { SearchRequest } from "../../data/app-core/search-request";
import { OrganizationalUnit } from "../../data/app-core/organizational-unit";
import { AuthProviderContactResult } from "../result/auth-provider-contact-result";
import { PersonDocument } from "./documents/person-document";
import { ItemEnvelope } from "./base/item-envelope";

export class PersonEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Person");
		if (jsonEnvelope) {
			this.GroupsPool = jsonEnvelope.GroupsPool;
			this.CloakTypesPool = jsonEnvelope.CloakTypesPool;
			this.SearchRequestTypesPool = jsonEnvelope.SearchRequestTypesPool;
			this.SearchRequestsPool = jsonEnvelope.SearchRequestsPool;
			this.OrganizationalUnitsPool = jsonEnvelope.OrganizationalUnitsPool;
			this.AuthProviderContactsPool = jsonEnvelope.AuthProviderContactsPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public GroupsPool: Group[] = [];
	public CloakTypesPool: CloakType[] = [];
	public SearchRequestTypesPool: SearchRequestType[] = [];
	public SearchRequestsPool: SearchRequest[] = [];
	public OrganizationalUnitsPool: OrganizationalUnit[] = [];
	public AuthProviderContactsPool: AuthProviderContactResult[] = [];
	public override Document: PersonDocument = new PersonDocument();
	public override get ItemId(): number { return this.Document.Item.PersonId; }
	public override get ItemName(): string { return this.Document.Item.FirstName + " " + this.Document.Item.LastName; }
}